import * as React from 'react';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import './index.less';

/**
 * 弹窗模板, 可以快速套用修改
 */
const Layout = ({ isOpen, onClose, children, className, ...rest }) => {
  return (
    <ModalContainer modalState={isOpen} className={className} {...rest}>
      <div className="modal-container">
        <Link className="modal-close" onClick={onClose} />
        <div className="modal-content">{children}</div>
      </div>
    </ModalContainer>
  );
};

export default Layout;
